<template>
    <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow">
        <div class="hero-overlay-card" :class="getBackgroundClass()">
            <div :class="getContainerClass()">
                <div class="inner-card-container">
                    <SmartLinkStandaloneElement :codename="contentTypes.hero_overlay_card.elements.title.codename">
                        <h1 class="title" v-if="model?.elements.title.value">
                            {{ model?.elements.title.value }}
                        </h1>
                    </SmartLinkStandaloneElement>
                    <SmartLinkStandaloneElement :codename="contentTypes.hero_overlay_card.elements.sub_title.codename">
                        <h2 class="subtitle" v-if="model?.elements.subTitle.value">
                            {{ model?.elements.subTitle.value }}
                        </h2>
                    </SmartLinkStandaloneElement>
                    <SmartLinkStandaloneElement :codename="contentTypes.hero_overlay_card.elements.content.codename">
                        <div class="content" v-if="!isEmpty(model?.elements.content.value)">
                            <p>{{ model?.elements.content.value }}</p>
                        </div>
                    </SmartLinkStandaloneElement>
                    <LinkedItemComponent v-for="cta in data.ctas" :model="cta" />
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { CallToActionModel, HeroOverlayCardModel } from '~/models';
import { isEmpty } from '~/utils/kontent-helper';
import { contentTypes } from '~/models';


const props = defineProps<{ model: HeroOverlayCardModel }>();
const pageStore = usePageStore();

const data = {
    title: props.model.elements.title.value,
    subTitle: props.model.elements.subTitle.value,
    content: props.model.elements.content.value,
    ctas: pageStore.getListAs<any>(props.model.elements.callToAction.value),
    addPadding: multipleChoiceToBoolean(props.model.elements.addBottomPadding),
    background: firstOrDefault(props.model.elements.background.value),
}

const hasHeroOverlay = useState<boolean>('hasHeroOverlay', () => true);

hasHeroOverlay.value = true;

function getContainerClass() {
    let result = 'container'

    if (data.addPadding) {
        result = `${result} bottom-padding`;
    }
    return result;
}

function getBackgroundClass() {
  if (data.background?.codename === 'dark') {
    return 'dark-gray-bg'
  }
  else if (data.background?.codename === 'light') {
    return 'light-gray-bg'
  }
  return ''
}

</script>

<style lang="scss" scoped>
</style>
